import React, {Component} from 'react';
import { __ } from "i18n-for-browser";

import BudgetCollaboration from "../elements/StepThree/BudgetCollaboration";

import Single from "../../assets/img/icons/single.png";
import Group from "../../assets/img/icons/group.png";
import Check from "../../assets/img/icons/check.svg";
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";
import PopupTitle from "../elements/PopupTitle";
import PopUp from "../elements/PopUp";

import config from '../../config';
import Global from '../../assets/img/icons/global.svg';

class PolicyElement extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    globas: PropTypes.number,
    collaborationGlobas: PropTypes.number,
    value: PropTypes.object,
    // value obj is:
    // globas: PropTypes.number,
    // option: PropTypes.string,
    // selected: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {open: false};
    this.onCollabChange = this.onCollabChange.bind(this);
    this.selectOption = this.selectOption.bind(this);
    //this.openClose = this.openClose.bind(this);
  }

  collaborationEl = React.createRef();
  policyOptions = React.createRef();
  policyHeader = React.createRef();

  selectOption(selected) {
    if (this.props.value.option !== selected) {
      this.setValues({
        option: selected,
        selected: true,
        collaboration: [],
      });
    } else {
      this.setValues({
        option: '',
        selected: false
      })
    }
  }

  componentDidUpdate(oldProps) {
    const { props } = this;
    if (oldProps&&
      props.value.option!==oldProps.value.option &&
      this.collaborationEl &&
      props.value.option === 'collab')
    {
      if (this.collaborationEl.current) {
        this.collaborationEl.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  openClose() {
    if (!this.state.open) {
      this.setState(prevState => ({
        open: !prevState.open
      }), () => {
        if (this.state.open) {
          if (this.policyOptions.current) {
            this.policyOptions.current.scrollIntoView({behavior: 'smooth'});
          }
        } else {
          if (this.policyHeader.current) {
            this.policyHeader.current.scrollIntoView({behavior: 'smooth'});
          }
        }
      });
    }
  }

  onCollabChange(key, val) {
    this.setValues({ 'collaboration': val });
  }

  setValues(values) {
    const v = {
      title: this.props.title,
      option: this.props.value.option,
      selected: this.props.value.selected,
      collaboration: this.props.value.collaboration,
      ...values
    };
    v.globas = 0;
    if(v.option === 'collab') v.globas = this.props.collaborationGlobas;
    if(v.option === 'single') v.globas = this.props.globas;
    this.props.onChange(v);
  }

  render() {
    const {props} = this;
    const {value, schoolClass} = props;
    let title;
    let maxGlobas, rows;
    let globas = props.globas;

    if (props.collaborationGlobas) {
      title = globas + '/' + props.collaborationGlobas;
      maxGlobas = props.collaborationGlobas;
    } else {
      title = props.globas;
      maxGlobas = props.globas;
    }

    if (value.collaboration) {
      rows = 'three';
      if (value.collaboration.length <= 2) {
        rows = 'one';
      } else if (value.collaboration.length <= 4) {
        rows = 'two';
      }
    }

    const groupBadge = (name, i) => {
      let matchedGroup = schoolClass.Groups.find(g => g.GroupTheme.color === name);
      if (matchedGroup) return <img key={i} className={'collab-inline-item-badge'} src={`${config.apiUrl}${matchedGroup.GroupTheme.badge}`} alt={'badge'} />;
    };

    return (
      <div className="policy-element-pos">
        <div onClick={() => this.openClose()} className={'policy-element' + (!this.state.open ? ' closed' : '') + (value.selected ? ' checked' : '')}>
          <div
            className={'policy-header-element'}
            ref={this.policyHeader}>

            <h4>
              { value.selected ?
                <img
                  src={Check}
                  alt={'selected'}
                  className={'selected'}/>
                : null }
              {props.title}
            </h4>

            {value.collaboration ?
              <div className={'collab-icons ' + rows}>
                {value.collaboration.map((group, i) => (
                  <span key={i}>
                    {groupBadge(group, i)}
                  </span>
                ))}
              </div> : null
            }

            <div className='point-holder'>
              <div className={'point-holder-details'}>
                <span title={title}>{title}
                </span>
                <p title='Miljard'>Miljard</p>
              </div>
            </div>
          </div>
          {this.state.open ?
            <PopUp closePopUpClick={() => this.setState({open: false})} interactive={true} closePopUpCross={true} hideClose={false}>
              <div className={'hidden-content policy-choice-popup-content'}>
                <h4>{props.title} {props.collaborationGlobas ? <img style={{ height: '14px', marginTop: '-2px' }} src={Global} className="global-icon" alt="global-icon" /> : null}</h4>

                <p className={'desc'}>{props.children}</p>

                <div className={'policy-options'} ref={this.policyOptions}>
                  <PopupTitle popupId={'mhgvtselecteerbeleidskeuze'} tag={'h5'}/>

                  <ul className={'options' + (this.props.user.role === 'groupmember' ? ' groupmember-disabled' : '')}>
                    <li
                      className={'delay-30 option' + (value.option === 'single' ? ' active' : '')}
                      onClick={this.selectOption.bind(this, 'single')}>
                      <img alt="Avatar" src={Single}/>

                      <div className='point-holder'>
                        <div className={'point-holder-details'}>
                          <span title={props.globas}>{props.globas}</span>
                          <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
                        </div>
                      </div>
                    </li>
                    {props.collaborationGlobas ?
                      <li
                        className={'delay-45 option' + (value.option === 'collab' ? ' active' : '')}
                        onClick={this.selectOption.bind(this, 'collab')}>
                        <img alt="Group" src={Group}/>

                        <div className='point-holder'>
                          <div className={'point-holder-details'}>
                            <span title={maxGlobas}>{maxGlobas}</span>
                            <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
                          </div>
                        </div>
                      </li>
                      : '' }
                  </ul>
                </div>

                <div
                  className={'show-hide-collab ' + (value.option === 'collab' ? ' show' : '')}
                  ref={this.collaborationEl}>

                  <BudgetCollaboration
                    customOnChange={this.onCollabChange}
                    value={props.value.collaboration}
                    title={__('sim_selecteer_samenwerk_landen') + ':'}/>
                </div>
              </div>
            </PopUp> : ''
          }
        </div>
      </div>
    )
  }
}

export default connect(({schoolClass, user}) => ({schoolClass, user}))(PolicyElement);



// WEBPACK FOOTER //
// ./src/components/desktop/PolicyElement.js